/*
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-08-20 16:40:17
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 16:42:09
 * @FilePath: \partner.chaoyongtuan.com\src\api\businessGroup.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';
// 获得登录用户的团队列表
export const getTenantList = params => {
	return request({
		url: '/api/official-account/tenant-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
